export default {
	"activate.GetTheVerificationCode": "獲取驗證碼",
	"activate.Resend": "重新發送",
	"activate.PleaseEnterYourPhoneNumber": "請輸入手機號",
	"activate.PleaseEnterTheCorrectMobilePhoneNumber": "請輸入正確的手機號",
	"activate.please": "請",
	"activate.sResendAfterThat": "s之後再重新發送",
	"activate.FailedToGetVerificationCode": "獲取驗證碼失敗",
	"activate.TheVerificationCodeIsNotLegitimate": "驗證碼不合法",
	"activate.TheVerificationCodeIsIncorrect": "驗證碼錯誤",
	"activate.ThePhoneNumberThatReceivesTheActivationCode": "接收啟動碼的手機號",
	"activate.VerificationCode": "驗證碼",
	"activate.EnquireNow": "立即查詢",
	"activate.TheActivationCodeIsAProductRedemptionVoucherObtainedFromAThirdPartyAndCanBeRedeemedForTheCorrespondingProduct": "啟動碼是從第三方獲取的商品兌換憑證，可兌換相應的商品"
}